export default __webpack_public_path__ + "static/media/DSC_0058.602a58d7.jpg";